import { useMutation } from 'react-query';
import { getWorkerExistsByEmail } from 'shared/services/worker-service';
import { GetWorkerExistsByEmailParams } from 'shared/services/worker-service.types';

export const useWorkerExistsByEmail = () => {
  return useMutation<boolean, Error, GetWorkerExistsByEmailParams>({
    mutationFn: getWorkerExistsByEmail,
  });
};
